import {TranslateService} from "@ngx-translate/core";
import {inject, InjectionToken} from "@angular/core";

export const FORM_ERRORS = new InjectionToken<any>('FORM_ERRORS', {
    providedIn: 'root',
    factory: () => {
        const translate = inject(TranslateService);
        return {
            required: () => translate.instant('messages.error.form.field_is_required'),
            email: () => translate.instant('messages.error.form.field_invalid_email'),
            min: ({min}: any) => translate.instant('messages.error.form.field_min_value', {min}),
            max: ({max}: any) => translate.instant('messages.error.form.field_max_value', {max}),
            minlength: ({requiredLength}: any) => {
                return translate.instant('messages.error.form.field_min_length', {minlength: requiredLength})
            },
            maxLength: ({requiredLength}: any) => translate.instant('messages.error.form.field_max_length', {maxlength: requiredLength}),
            matching: () => translate.instant('messages.error.form.field_match'),
            strongPassword: () => translate.instant('messages.error.form.field_invalid_password'),
            inUse: () => translate.instant('messages.error.form.field_in_use'),
            invalidUrl: () => translate.instant('messages.error.invalid_url'),
        };
    }
});
